module.exports = __webpack_public_path__ + "img/nav-arrow.38f1d324.svg";